import React, { useState, useEffect } from 'react'
import { Button, Col, Icon, Message, Panel, Row } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import InfoManageDurableArticles from '../manageDurableArticles/InfoManageDurableArticles'
import ManageDurableArticlesTable from '../manageDurableArticles/ManageDurableArticlesTable'
import ManageDurableArticlesForm from '../manageDurableArticles/ManageDurableArticlesForm'
import ManageDurableArticlesView from './ManageDurableArticlesView'
import ClosureRequestAssetWidget from './ClosureRequestAssetWidget'
import {
  sessionGetItemStr,
  sessionRemoveItem,
  sessionSetItemStr,
} from '../../../utils/sessionHelpers'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import AlertWidget from '../../confirm/AlertWidget'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import {
  saveResponsinatorAssetClosureRequest,
  downloadAssetClosureAttacthment,
  updateApproveLevel1AssetClosureRequest,
  updateApproveLevel2AssetClosureRequest,
  downloadFileByPath,
  updateResponsinatorAssetClosureRequest,
  cancelAssetClosure,
  downloadAssetClouerRegisterFile,
} from '../../../redux/actions/accountingAssetClosure'
import notification from '../../../utils/notification'
import moment from 'moment'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import InputForm from '../../../components/forms/input/InputForm'
import { ASSET_CLOSURE_STEP } from '../../../constants/assetClosureStep'
import pathname from '../../../constants/pathname'
import EditButton from '../../../components/buttons/editButton/EditButton'
import ManageDurableArticlesAttch from './ManageDurableArticlesAttch'
import {
  DEFAULT_ERR_MSG,
  SAVE_ERR_MSG,
  SAVE_SUCCESS_MSG,
  SUCCESS_MSG,
} from '../../../constants/msgText'
import { forEach, isEmpty } from 'lodash-es'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import MiniProjectInfo from '../../projectBasedItemsWidget/MiniProjectInfo'

export default function ManageDurableArticlesWidget({ schema, ...props }) {
  const { isEdit } = props
  const history = useHistory()

  // console.log('is edit ', !isEdit)

  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(schema)
  const [listItemSelected, setListItemSelected] = useState([])
  const [listItemType, setListItemType] = useState(false)
  const [isShowModalHelper, setIsShowModalHelper] = useState(false)
  const [countList, setCountList] = useState(0)
  const [searchRequest, setSearchRequest] = useState({})
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmStep2, setIsShowConfirmStep2] = useState(false)
  const [isShowConfirmApprove, setIsShowConfirmApprove] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [request, setRequest] = useState()
  const [secondRequest, setSecondRequest] = useState()
  const [approveType, setApproveType] = useState()
  const [isFilesRequired, setIsFilesRequired] = useState(false)
  const [isFilesMsg, setIsFilesMsg] = useState(false)
  const [manageType, setManageType] = useState([
    ...new Set(schema?.form?.closureTypes?.map((item) => item.closureType + '') || []),
  ])

  const [reload, setReload] = useState(false)

  const projectCode = sessionGetItemStr('projectCode')
  const assetClosureId = sessionGetItemStr('assetClosureId')
  const assetClosureStep = sessionGetItemStr('assetClosureStep')

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      notification.open('error', {
        title: 'กรุณากรอกข้อมูลให้ครบ',
      })
    }
  }, [errors])

  const onSelect = (type, chk, count) => {
    console.log('onSelect=> ', type, chk, count)
    setListItemSelected(chk)
    // setCountList(type ? count : chk.length)
    setListItemType(type)
  }

  const onCancel = () => {
    sessionRemoveItem('assetClosureId')
    history.goBack()
  }

  const countSelected = (data) => {
    //let count = 0

    // const checkKeys = [
    //   'attachFiles',
    //   'chkRow',
    //   'dataTable',
    //   'note',
    //   'CommeteeCoordinatorName',
    //   'CommeteeStaffName',
    //   'commeteeResponsinatorName',
    // ]
    // for (const [k, v] of Object.entries(data)) {
    //   if (!checkKeys.includes(k)) {
    //     count++
    //   }
    // }
    //
    //return count

    return data.dataTable.filter((e) => e.checked).length
  }

  const onSubmit = (data) => {
    console.log('data : ', data)
    // console.log('listItemSelected : ', listItemSelected)
    // console.log('searchRequest ', searchRequest)

    const formData = new FormData()
    if (assetClosureStep == 0 && !formSchema?.disabled && formSchema?.closureStatus == 2) {
      //กรณีส่งกลับแก้ไข

      var count = data?.table?.length || 0
      // console.log(count)
      setCountList(count)

      data.table.map((item, index) => {
        formData.set(`Details[${index}].Id`, item.id)
        formData.set(`Details[${index}].ClosureType`, item.closureType)
      })
    } else if (countSelected(data) <= 0) {
      setIsShowModalHelper(true)
      return false
    } else {
      //setCountList(countSelected(data) || 0)

      if (data.dataTable.length > 0) {
        let c = 0
        data.dataTable.map((item) => {
          if (item.checked) {
            formData.set(`Details[${c}].Id`, item.id)
            formData.set(`Details[${c}].ClosureType`, item.closureType)
            c++
          }
        })

        setCountList(c)
      }
    }

    formData.append('Id', assetClosureId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('CommeteeCoordinatorName', data?.CommeteeCoordinatorName || '')
    formData.append('CommeteeStaffName', data?.CommeteeStaffName || '')
    formData.append('CommeteeResponsinatorName', data?.commeteeResponsinatorName || '')
    formData.append('Note', data?.note || '')

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds &&
      data.deleteFileIds?.forEach((element) => {
        formData.append('DeleteFileIds', element)
      })

    setRequest(formData)
    setIsShowConfirm(true)
  }

  const onSubmitUpdate = (data) => {
    const formData = createStep2Request(data, false)

    handleCallUpdateService(formData, false)
  }

  const onSubmitSecondRequest = (data) => {
    if (validAttachment(data)) {
      notification.open('error', {
        title: 'กรุณาแนบไฟล์ เอกสารประกอบการพิจารณาที่มี * ให้ครบ',
        duration: 8000,
      })
      setIsFilesMsg(true)
      // setIsFilesRequired(true)
      return false
    } else {
      setIsFilesMsg(false)
    }

    const formData = createStep2Request(data, true)

    setSecondRequest(formData)
    setIsShowConfirmStep2(true)
  }

  const validAttachment = (data) => {
    let requireAttachs =
      formSchema?.form?.attachment
        ?.filter(
          (e) =>
            e.name.includes('Attachment_') &&
            (isEmpty(e.filePath) || data['delAttchIds']?.includes(e.fileId)) &&
            e.isRequired
        )
        ?.map((item) => {
          return item
        }) || []

    var errorRequireAttachs = []

    if (requireAttachs != null && requireAttachs.length > 0) {
      errorRequireAttachs = requireAttachs.filter((e) => isEmpty(data[e.name])) || []
    }

    return errorRequireAttachs.length > 0
  }

  const createStep2Request = (data, requestApprove) => {
    console.log('data : ', data)
    const formData = new FormData()

    formData.append('Id', assetClosureId || '')
    formData.append('ProjectCode', projectCode || '')
    formData.append('RequestApprove', requestApprove)

    formData.append('CommeteeCoordinatorName', data?.CommeteeCoordinatorName || '')
    formData.append('CommeteeStaffName', data?.CommeteeStaffName || '')
    formData.append('CommeteeResponsinatorName', data?.commeteeResponsinatorName || '')
    formData.append('Note', data?.note || '')

    data.attachFiles &&
      data.attachFiles?.forEach((element) => {
        formData.append('AttachFiles', element.blobFile)
      })

    data.deleteFileIds?.forEach((element) => {
      formData.append('DeleteFileIds', element)
    })

    data.delAttchIds?.forEach((element) => {
      formData.append('DeleteFileIds', element)
    })

    if (data?.table?.length > 0) {
      data.table?.forEach((item, index) => {
        formData.set(`Details[${index}].Id`, item.id)
        formData.set(`Details[${index}].ClosureType`, item.closureType)

        switch (item.closureType) {
          case 1:
            formData.set(`Details[${index}].ReserveProject`, item.reserveProject || '')
            formData.set(`Details[${index}].ReserveProjectState`, item.reserveProjectState || '')
            break
          case 2:
            let billIngDate = item.billIngDate || data[`billIngDate_${item.id}`]

            formData.set(`Details[${index}].BuyerName`, item.buyerName || '')
            formData.set(`Details[${index}].SalePrice`, item.salePrice || 0)
            formData.set(`Details[${index}].BillIngDocNo`, item.billIngDocNo || '')
            formData.set(
              `Details[${index}].BillIngDate`,
              billIngDate ? moment(billIngDate).format('YYYY/MM/DD') : ''
            )

            break
          case 3:
            let donateDocDate = item.donateDocDate || data[`donateDocDate_${item.id}`]

            formData.set(`Details[${index}].DonateToName`, item.donateToName || 0)
            formData.set(`Details[${index}].DonateDocNo`, item.donateDocNo || '')
            formData.set(
              `Details[${index}].DonateDocDate`,
              donateDocDate ? moment(donateDocDate).format('YYYY/MM/DD') : ''
            )
            break
          case 4:
            formData.set(`Details[${index}].ReserveProject`, item.reserveProject || '')
            break
          case 5:
            let destroyDate = item.destroyDate || data[`destroyDate_${item.id}`]

            formData.set(
              `Details[${index}].DestroyDate`,
              destroyDate ? moment(destroyDate).format('YYYY/MM/DD') : ''
            )
            break
          case 6:
            let exchangeDate = item.exchangeDate || data[`exchangeDate_${item.id}`]

            formData.set(`Details[${index}].ExchangeOrg`, item.exchangeOrg || '')
            formData.set(
              `Details[${index}].ExchangeDate`,
              exchangeDate ? moment(exchangeDate).format('YYYY/MM/DD') : ''
            )
            break
          default:
            break
        }
      })
    }

    let keys = Object.keys(data)?.filter((e) => e.startsWith('Attachment_'))

    let index = 0

    keys?.forEach((key) => {
      if (data[key]) {
        data[key]?.forEach((element) => {
          var keys = key?.split('_') || []

          formData.set(`Attachs[${index}].MasterId`, keys?.pop())
          formData.set(`Attachs[${index}].File`, element.blobFile || null)

          index++
        })
      }
    })

    return formData
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await saveResponsinatorAssetClosureRequest(request)
      console.log('response ', response)
      if (response.model) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        sessionSetItemStr('assetClosureId', response.model.id)
        setFormSchema(response.model)
        setRequest()
        setIsShowConfirm(false)
        setReload(true)
        setTimeout(() => {
          // location.reload()
          setReload(false)
          //history.goBack()
        }, 500)
      } else {
        setIsError()
      }
    } catch (e) {
      console.log('error', e)
      setIsError(e?.response?.data?.errorMessage)
      setIsShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleCallUpdateService = async (request, isRequest) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await updateResponsinatorAssetClosureRequest(request)
      console.log('handleCallUpdateService Response ', response)
      if (response?.model) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
          duration: 3000,
        })

        setTimeout(() => {
          // location.reload()
          history.goBack()
        }, 500)

        // if (isRequest) {
        //   setTimeout(() => {
        //     // location.reload()
        //     history.goBack()
        //   }, 500)
        // } else {
        //   setFormSchema(response.model)
        // }
      } else {
        setIsError()
      }
    } catch (e) {
      console.log('error', e)
      setIsError(e?.response?.data?.errorMessage)
    }

    setSecondRequest(null)
    setIsShowConfirmStep2(false)
    setIsLoading(false)
    doneLoading()
  }

  const setIsError = (message) => {
    notification.open('error', {
      title: message || DEFAULT_ERR_MSG,
      duration: 5000,
    })
  }

  const createRequest = (submitData) => {
    console.log('submitData => ', submitData)
    const formData = new FormData()

    if (assetClosureStep == ASSET_CLOSURE_STEP.REQUEST_STEP_1) {
      Object.keys(submitData).forEach((key) => {
        if (key.indexOf('Attachment_') != -1) {
          console.log(key.indexOf('Attachment_'))

          if (submitData[key]) {
            submitData[key]?.forEach((element) => {
              formData.append(key, element.blobFile || null)
            })
          } else {
            formData.append(key, null)
          }
        }
      })
    }

    formData.append('Id', assetClosureId)
    formData.append('ApproveType', approveType)
    formData.append('Note', submitData.approverComment)

    return formData
  }

  const handleCallServiceApprove = async (data) => {
    console.log('handleCallServiceApprove ', data)

    startLoading()
    setIsLoading(true)
    try {
      // 0 ส่งกลับแก้ไข 1 อนุมัติ
      const request = {
        id: assetClosureId,
        approveType: approveType,
        note: data.approverComment,
      }

      let response = null
      if (
        assetClosureStep == ASSET_CLOSURE_STEP.REQUEST_STEP_1 ||
        assetClosureStep == ASSET_CLOSURE_STEP.REQUEST_STEP_2
      ) {
        // เสนอพืจารณาอนุมัติคำขอปิดครุภัณฑ์ นักวิชาการ/จนท.พัสดุ
        // const request = createRequest(data)
        response = await updateApproveLevel1AssetClosureRequest(request, assetClosureStep)
      } else if (
        assetClosureStep == ASSET_CLOSURE_STEP.APPROVE_STEP_1 ||
        assetClosureStep == ASSET_CLOSURE_STEP.APPROVE_STEP_2
      ) {
        // อนุมัติคำขอปิดครุภัณฑ์ ผอ./ผอ.อำนวยการ
        response = await updateApproveLevel2AssetClosureRequest(request, assetClosureStep)
      } else {
        notification.open('error', {
          title: SAVE_ERR_MSG,
        })

        setIsLoading(false)
        return false
      }

      console.log('response ', response)
      if (response) {
        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })

        setIsShowConfirmApprove(false)
        setApproveType()
        setTimeout(() => {
          let xurl = ''
          if (assetClosureStep == ASSET_CLOSURE_STEP.REQUEST_STEP_1) {
            xurl = pathname.durableArticles.ClosureApproveRequest1
          } else if (assetClosureStep == ASSET_CLOSURE_STEP.APPROVE_STEP_1) {
            xurl = pathname.durableArticles.ClosureApproval1
          } else if (assetClosureStep == ASSET_CLOSURE_STEP.REQUEST_STEP_2) {
            xurl = pathname.durableArticles.ClosureApproveRequest2
          } else if (assetClosureStep == ASSET_CLOSURE_STEP.ClosureApproval2) {
            xurl = pathname.durableArticles.ClosureApproveRequest2
          } else {
            history.goBack()
          }

          history.push({
            //pathname: `${pathname.durableArticles.ClosureApproveRequest1}`,
            pathname: `${xurl}`,
          })
        }, 1000)
      } else {
        setIsError()
      }
    } catch (e) {
      console.log('error', e)
      setIsError(e?.response?.data?.errorMessage)
      setIsShowConfirm(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handlePreviewFile = async (fileObj) => {
    console.log('handlePreviewFile ', fileObj)

    startLoading()
    try {
      var file = await downloadAssetClosureAttacthment(fileObj.id)
      var fileName = fileObj.name

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDownloadFile = async (fileObj) => {
    console.log('handleDownloadFile ', fileObj)

    startLoading()
    try {
      var file = await downloadAssetClosureAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDeleteFile = (rowData) => {
    console.log('handleDeleteFile ', rowData)
  }

  const handleDownloadPreviewFile = async (fileObj, type) => {
    console.log('handleDownloadPreviewFile ', fileObj)

    startLoading()
    try {
      var mannul = ['asset_1']
      var file

      if (mannul.includes(fileObj.id) && isEmpty(fileObj.filePath)) {
        file = await downloadAssetClouerRegisterFile(projectCode, assetClosureId)
      } else {
        file = await downloadFileByPath(fileObj.filePath)
      }

      var fileName = fileObj.label

      if ('download' == type) {
        downloadFile(file, fileName)
      } else if ('preview' == type) {
        previewFile(file, fileName)
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleCancel = async () => {
    startLoading()
    setIsLoading(true)
    try {
      const response = await cancelAssetClosure(assetClosureId)
      if (response) {
        notification.open('success', {
          title: 'ยกเลิกสำเร็จ',
        })
        setIsShowConfirmDelete(false)
        history.goBack()
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    setIsShowConfirmDelete(false)
    setIsLoading(false)
    doneLoading()
  }

  const onAddFile = async (fileObj) => {
    handleDownloadPreviewFile(fileObj, 'download')
  }

  const onDelFile = async (fileObj, index) => {
    console.log(fileObj)

    if (isEmpty(fileObj.id)) {
    }
  }

  const onDownloadApproveFile = async (fileObj) => {
    handleDownloadPreviewFile(fileObj, 'download')
  }

  const onPreviewApproveFile = (fileObj) => {
    handleDownloadPreviewFile(fileObj, 'preview')
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={
          <>
            {formSchema.header} {formSchema.closureDocNo ? ` (${formSchema.closureDocNo})` : ''}
          </>
        }
        bordered
      >
        {isLoading && <OverlayLoader />}

        {/* <InfoManageDurableArticles schema={formSchema?.projectInfo} /> */}
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {!reload && (
          <>
            {!formSchema.disabled && assetClosureStep == 0 ? (
              <>
                {
                  /*!formSchema?.isApprovedStep1 &&*/
                  (assetClosureId == null || assetClosureId == '') && (
                    <>
                      <ClosureRequestAssetWidget
                        onSelected={onSelect}
                        searchRequestBody={(req) => {
                          setSearchRequest(req)
                        }}
                        projectCode={projectCode}
                        selectManageType={setManageType}
                        Controller={Controller}
                        register={register}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        getValues={getValues}
                        setError={setError}
                        clearErrors={clearErrors}
                      />

                      <hr />
                    </>
                  )
                }

                {formSchema?.form?.formTable?.values?.length > 0 && (
                  <ManageDurableArticlesTable
                    loading={isLoading}
                    schema={formSchema?.form?.formTable}
                    enableManage={
                      assetClosureStep == 0 &&
                      !formSchema?.disabled &&
                      (formSchema?.closureStatus == 0 || formSchema?.closureStatus == 2)
                    }
                    isEdit={
                      assetClosureStep == 0 && !formSchema?.disabled && formSchema?.isApprovedStep1
                    }
                    enableSelect={formSchema.enableSelect}
                    isSendBackStep1={
                      assetClosureStep == 0 &&
                      !formSchema?.disabled &&
                      formSchema?.closureStatus == 2
                    }
                    Controller={Controller}
                    register={register}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    getValues={getValues}
                    setError={setError}
                    clearErrors={clearErrors}
                    selectClosureType={(value) => {
                      setManageType(value)
                    }}
                    closureType={manageType}
                  />
                )}

                <ManageDurableArticlesForm
                  schema={formSchema?.form}
                  Controller={Controller}
                  register={register}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  getValues={getValues}
                  setError={setError}
                  clearErrors={clearErrors}
                  onPreview={handlePreviewFile}
                  onDownload={handleDownloadFile}
                  onDelete={handleDeleteFile}
                  manageTypeVal={manageType}
                />
              </>
            ) : (
              <>
                <ManageDurableArticlesTable
                  loading={isLoading}
                  schema={formSchema?.form?.formTable}
                  Controller={Controller}
                  register={register}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  getValues={getValues}
                  setError={setError}
                  clearErrors={clearErrors}
                />

                <ManageDurableArticlesView
                  schema={formSchema?.form}
                  onPreview={handlePreviewFile}
                  onDownload={handleDownloadFile}
                />
              </>
            )}

            {/* //ความเห็น */}
            {formSchema?.form.comments?.length > 0 && (
              <Row style={{ marginTop: 20 }}>
                <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <b>ความเห็น</b>
                </Col>
              </Row>
            )}
            {formSchema?.form.comments?.map((item) => {
              return (
                <Row style={{ marginTop: 10 }}>
                  <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    {`${item.label} : `}
                  </Col>
                  <Col lg={18} md={18} sm={24} xs={24}>
                    <Message type={item.type || 'info'} description={item.value} />
                  </Col>
                </Row>
              )
            })}

            {((assetClosureStep == ASSET_CLOSURE_STEP.USER &&
              (formSchema?.isApprovedStep1 ||
                (!formSchema?.isApprovedStep1 && formSchema.disabled)) &&
              formSchema?.form?.attachment) ||
              (assetClosureStep != ASSET_CLOSURE_STEP.USER && formSchema?.form?.attachment)) && (
              <>
                <hr />
                <ManageDurableArticlesAttch
                  loading={isLoading}
                  schema={formSchema?.form?.attachment}
                  Controller={Controller}
                  register={register}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  getValues={getValues}
                  setError={setError}
                  clearErrors={clearErrors}
                  onPreview={onPreviewApproveFile}
                  onDownload={onDownloadApproveFile}
                  isEnableUpload={
                    assetClosureStep == ASSET_CLOSURE_STEP.USER && !formSchema.disabled
                  }
                  isFileRequired={isFilesMsg}
                />
              </>
            )}
          </>
        )}

        <hr />
        <Row
          style={{
            marginTop: 10,
            textAlign: 'right',
          }}
        >
          <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'left' }}>
            {
              //!isEmpty(formSchema.id) && assetClosureStep == 0 && !formSchema.disabled
              formSchema.form.button.reject && (
                <Button
                  color="red"
                  appearance="link"
                  disabled={isLoading}
                  onClick={() => {
                    setIsShowConfirmDelete(true)
                  }}
                >
                  <Icon icon="trash" size="lg" />
                  {formSchema.form.button.reject || 'ยกเลิกคำขอปิดครุภัณฑ์โครงการ'}
                </Button>
              )
            }
          </Col>

          <Col lg={16} md={16} sm={24} xs={24}>
            {/* ส่งพิจารณา ขั้นต้น */}
            {formSchema.form.button.request &&
              assetClosureStep == 0 &&
              !formSchema.isApprovedStep1 && (
                <SaveButton
                  disabled={formSchema.disabled || isLoading}
                  // icon="send"
                  onClick={handleSubmit(onSubmit)}
                >
                  {/* {`${formSchema.form.button.request} ขั้นต้น`} */}
                  {`${formSchema.form.button.request}`}
                </SaveButton>
              )}

            {/* ส่งพิจารณา ขั้นสอง */}
            {formSchema.form.button.request &&
              assetClosureStep == 0 &&
              formSchema.isApprovedStep1 && (
                <SaveButton
                  disabled={formSchema.disabled || isLoading}
                  icon="send"
                  onClick={handleSubmit(onSubmitSecondRequest)}
                >
                  {formSchema.form.button.request}
                </SaveButton>
              )}

            {/* ส่งกลับแก้ไข */}
            {formSchema.form.button.sendBack && assetClosureStep != 0 && (
              <EditButton
                disabled={formSchema.disabled}
                icon="reply"
                onClick={() => {
                  setApproveType(0)
                  setIsShowConfirmApprove(true)
                }}
              >
                {formSchema.form.button.sendBack}
              </EditButton>
            )}

            {/* เสนออนุมัติ */}
            {formSchema.form.button.approve && assetClosureStep != 0 && (
              <SaveButton
                disabled={formSchema.disabled}
                icon="send"
                onClick={() => {
                  setApproveType(1)
                  setIsShowConfirmApprove(true)
                }}
              >
                {formSchema.form.button.approve}
              </SaveButton>
            )}

            {/* บันทึก */}
            {formSchema.form.button.save && (
              <SaveButton disabled={isLoading} onClick={handleSubmit(onSubmitUpdate)}>
                {formSchema.form.button.save}
              </SaveButton>
            )}

            {formSchema.form.button.cancel && (
              <CancelButton onClick={onCancel} disabled={isLoading}>
                {formSchema.form.button.cancel}
              </CancelButton>
            )}
          </Col>
        </Row>
      </Panel>

      <AlertWidget
        size="sm"
        title={globalMsgUtil.WARN_SELECTED_ITEM_TITLE}
        show={isShowModalHelper}
        detail={<div>{globalMsgUtil.WARN_SELECTED_ITEM_DETAIL_APPROVE}</div>}
        onClose={() => {
          setIsShowModalHelper(false)
        }}
      />

      <ConfirmWidget
        title={`ยืนยัน${formSchema.form.button.request || ''}`}
        show={isShowConfirm}
        detail={
          <>
            {formSchema.form.button.request} {countList} รายการ{' '}
          </>
        }
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isShowConfirmStep2}
        detail={`ยืนยัน${formSchema.form.button.request || 'เสนอพิจารณา'}`}
        onCancle={() => {
          setSecondRequest(null)
          setIsShowConfirmStep2(false)
        }}
        onConfirm={() => {
          handleCallUpdateService(secondRequest, true)
        }}
      />

      <ConfirmWidget
        size="lg"
        title={'ยืนยัน'}
        show={isShowConfirmApprove}
        detail={
          <InputForm
            schema={formSchema.form.approverComment}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            rows={4}
            componentClass="textarea"
          />
        }
        onCancle={() => setIsShowConfirmApprove(false)}
        onConfirm={handleSubmit(handleCallServiceApprove)}
      />

      <ConfirmWidget
        title={'ยืนยัน'}
        show={isShowConfirmDelete}
        detail={`ยืนยันการยกเลิกคำขอ ${formSchema.closureDocNo}`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleCancel}
      />

      {/* <AlertWidget
        title={'แจ้งเตือน'}
        show={isFilesRequired}
        detail={`กรุณาแนบไฟล์ เอกสารประกอบการพิจารณา`}
        onClose={() => {
          setIsFilesRequired(false)
        }}
      /> */}
    </>
  )
}
